import React from 'react';

/**
 * Badges
 * Small reusable list of badges with a subtle glow animation.
 * Expects badges like: [{ type: 'diamond', value: 567, label: 'supporter of arjit' }]
 */
export default function Badges({ badges = [] }) {
    if (!Array.isArray(badges) || badges.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-2">
            {badges.map((b, idx) => (
                <div
                    key={idx}
                    className={`hub-badge hub-badge-${(b.type || 'default').toLowerCase()} flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-sm text-white`}
                    title={b.label || b.type}
                >
                    <span className="text-cyan-400">{iconFor(b.type)}</span>
                    <span className="whitespace-nowrap">{badgeText(b)}</span>
                </div>
            ))}
        </div>
    );
}

function iconFor(type) {
    switch ((type || '').toLowerCase()) {
        case 'diamond':
            return '💎';
        case 'star':
            return '⭐';
        case 'fire':
            return '🔥';
        case 'crown':
            return '👑';
        default:
            return '🏷️';
    }
}

function badgeText(b) {
    const label = b && (b.label || b.type) ? String(b.label || b.type) : 'Badge';
    if (b && typeof b.value !== 'undefined') return `${label} — ${b.value}`;
    return label;
}


